import { CoreOrganizationSettings } from './organizations';

export enum CoreUserRole {
  OWNER = 'owner',
  ADMIN = 'admin',
  READONLY = 'readonly',
  SERVICE = 'service',
}

export enum CoreUserInvitationStatus {
  ACCEPTED = 'accepted',
  PENDING = 'pending',
  UNSENT = 'unsent',
}

export type CoreUserOrganization = {
  id: string;
  name: string;
  force_sso_login: true;
  settings: CoreOrganizationSettings;
  brand_color_primary: string | null;
};

// User data returned by GET /v2/users
export type CoreUser = {
  id: string;
  email: string;
  full_name: string;
  organization: CoreUserOrganization;
  is_demo: boolean;
  phone_number: string | null;
  core_consent: boolean;
  marketing_consent: boolean;
  role: CoreUserRole;
  last_login: string | null;
  invitation_status: CoreUserInvitationStatus;
  created_at: string;
  spaces: Array<string>;
  is_editable: boolean;
  size_area_display_unit: string;
  permissions?: Array<string>;
};
